import React, { useEffect, useState } from "react";
import { Tag, Table, Typography, Space } from "antd";
import { useAtom } from "jotai";
import { documentosAtom, loadingAtom } from "pages/consulta-documento/ConsultaDocumentoStore";
import { EstadoDocumento } from "enum/EstadoDocumento";
import { EtiquetaEstadoNotificacion } from "../etiqueta-estado-notificacion";
import { EtiquetaEstadoVisualizacion } from "../etiqueta-estado-visualizacion";
import { EtiquetaEstadoFirmaColaborador } from "../etiqueta-estado-firma-colaborador";
import { MenuAcciones } from "../MenuAcciones";
import {
  MinusCircleOutlined,
  FileUnknownOutlined,
  SyncOutlined,
  LoadingOutlined,
  IdcardOutlined,
  MailOutlined
} from "@ant-design/icons";
import { CategoriaDocumento } from "enum/CategoriaDocumento";
const { Text } = Typography;

const TablaDocumentos = ({ onChangePagination }) => {
  const [documentos] = useAtom(documentosAtom);
  const [loading] = useAtom(loadingAtom);

  const columnas = [
    {
      title: "Colaborador",
      width: "25%",
      render: (documento) => <ColumnaColaborador documento={documento} />
    },
    {
      title: "Tipo Documento",
      dataIndex: ["envio", "tipoDocumentoNombre"],
      render: (text, fila) =>
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {fila.envio?.tipoDocumentoNombre ? fila?.envio?.tipoDocumentoNombre : fila?.categoriaDocumento?.nombre}
          </div>
          {fila.interno && (
            <div style={{ alignItems: "center" }}>
              <Tag color="blue">Documento Interno</Tag>
            </div>
          )}
          {
            fila.categoriaDocumentoId === CategoriaDocumento.CARGA_MANUAL
            && (
              // <div style={{ alignItems: "center" }}>
              <Tag color="processing" style={{ borderRadius: "10px", fontSize: "10px" }}>Carga Manual</Tag>
              // </div>
            )
          }
          {/* {
            fila.estadoDocumento === EstadoDocumento.CARGADO
            && (
              <div style={{ alignItems: "center" }}>
                <Tag color="cyan" style={{ borderRadius: "8px" }}>Carga Manual</Tag>
              </div>
            )
          } */}
        </div>
    },
    {
      title: "Periodo",
      dataIndex: "periodo",
      align: "center",
      width: "10%"
    },
    {
      title: "Notificación",
      dataIndex: "estadoNotificacion",
      align: "center",
      width: "5%",
      render: (text, fila) => {
        if (
          (fila.eliminado === false || fila.eliminado === null) &&
          (fila.estadoDocumento === EstadoDocumento.GENERADO
            || fila.estadoDocumento === EstadoDocumento.CARGADO
            || fila.estadoDocumento === null)
        ) {
          return <EtiquetaEstadoNotificacion documento={fila} />;
        }

        if (fila.eliminado === true) {
          return {
            children: (
              <span>
                <Tag color="default" icon={<MinusCircleOutlined />}>
                  INHABILITADO
                </Tag>
              </span>
            ),
            props: {
              colSpan: 3,
            },
          };
        }

        if (fila.estadoProcesoId && fila.estadoProcesoId === 6) {
          //PENDIENTE DE APROBAR
          return {
            children: (
              <span style={{ color: "#7d7939" }}>
                <FileUnknownOutlined /> Esperando aprobación ...
              </span>
            ),
            props: {
              colSpan: 3,
            },
          };
        }

        return {
          children: (
            <span style={{ color: "#7d7939" }}>
              <SyncOutlined spin style={{ color: "#7d7939" }} /> Procesando...
            </span>
          ),
          props: {
            colSpan: 3,
          },
        };
      },
    },
    {
      title: "Visualizado",
      dataIndex: "estadoVisualizacion",
      align: "center",
      width: "5%",
      render: (text, fila) => {
        // return <EtiquetaEstadoVisualizacion documento={fila} />
        if (
          (fila.eliminado === false || fila.eliminado === null) &&
          (fila.estadoDocumento === EstadoDocumento.GENERADO
            || fila.estadoDocumento === EstadoDocumento.CARGADO
            || fila.estadoDocumento === null)
        ) {
          return <EtiquetaEstadoVisualizacion documento={fila} />;
        }

        return {
          props: {
            colSpan: 0,
          },
        };
      },
    },
    {
      title: "Firmado",
      dataIndex: "estadoFirmaColaborador",
      align: "center",
      width: "5%",
      render: (text, fila) => {
        if (
          (fila.eliminado === false || fila.eliminado === null) &&
          (fila.estadoDocumento === EstadoDocumento.GENERADO
            || fila.estadoDocumento === EstadoDocumento.CARGADO
            || fila.estadoDocumento === null)
        ) {
          return <EtiquetaEstadoFirmaColaborador documento={fila} />;
        }

        return {
          props: {
            colSpan: 0,
          },
        };
      },
    },
    {
      title: "Acciones",
      // dataIndex: "menuAcciones",
      width: "5%",
      render: (text, fila) => <MenuAcciones envio={fila} />,
    },
  ];

  const expanded = {
    expandedRowRender: (record, i) => {
      return (
        <React.Fragment>
          {record?.colaborador != null && (
            <React.Fragment>
              <Space size={100}>
                <div style={{ marginLeft: "50px" }}>
                  <Text strong>{"Cargo: "}</Text>
                  {record?.colaborador.cargo != null ? (
                    <Tag color="blue" key={record.colaborador.cargo.id}>
                      {record.colaborador.cargo.nombre}
                    </Tag>
                  ) : (
                    <Tag color="default" key={record.colaborador.id}>
                      {"No Asignado"}
                    </Tag>
                  )}
                </div>
                <div>
                  <Text strong>{"Centro de Costo: "}</Text>
                  {record?.colaborador.sede != null ? (
                    <Tag color="blue" key={record.colaborador.sede.id}>
                      {record.colaborador.sede.nombre}
                    </Tag>
                  ) : (
                    <Tag color="default" key={record.colaborador.id}>
                      {"No Asignado"}
                    </Tag>
                  )}
                </div>
              </Space>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    },
  };

  return (
    <Table
      loading={{
        spinning: loading,
        indicator: <LoadingOutlined style={{ fontSize: 28 }} />,
        tip: "Cargando...",
      }}
      rowKey={(fila) => fila.id}
      dataSource={documentos.data}
      columns={columnas}
      expandable={{ ...expanded }}
      size="small"
      pagination={{
        size: "small",
        defaultCurrent: 1,
        current: documentos?.paginaActual,
        total: documentos.totalDocumentos,
        showTotal: (total) => `Total ${total} documentos`,
        pageSize: 30,
        onChange: (page) => onChangePagination(page),
      }}
    />
  );
};

const ColumnaColaborador = ({ documento }) => {
  return (
    <div>
      <div>
        <Typography.Text strong>
          {documento.colaborador.nombreCompleto}
        </Typography.Text>
      </div>
      <div>
        <div>
          <Typography.Text type="secondary">
            <Space>
              <MailOutlined style={{ fontSize: "16px" }} />
              {documento.colaborador.correoElectronico}
            </Space>
          </Typography.Text>
        </div>
        <div>
          <Typography.Text type="secondary">
            <Space>
              <IdcardOutlined style={{ fontSize: "16px" }} />
              {documento.colaborador.numeroDocumentoIdentidad}
            </Space>
          </Typography.Text>
        </div>
      </div>
    </div>
  )
}

export default TablaDocumentos;
